import { RowDataTransaction } from "../../components/TransactionPage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the TransactionTable factory
 */
class CoinsTransactionRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/coins/read-transaction-history-range"
        this.accessData = "history"
    }

    create(transaction: any): RowDataTransaction {
        const rowDataTransaction: RowDataTransaction = {
            transaction_id: transaction.transaction_id,
            fullname: transaction.fullname,
            coins: transaction.coins,
            type: transaction.type,
            remark: transaction.remarks,
            created_at: transaction.createdAt,
        };
        return rowDataTransaction;
    }
}

let coinsTransactionRow: CoinsTransactionRow | null = null;

export default function getCoinsTransactionRow(): CoinsTransactionRow {
    if (coinsTransactionRow === null)
        coinsTransactionRow = new CoinsTransactionRow()
    return coinsTransactionRow
}